// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
var NotificationSettingsPreferenceEditDialog = require("./NotificationSettingsPreferenceEditDialog.bs.js");
var NotificationSettingsForSaleProperties_chapter_graphql = require("../../__generated__/NotificationSettingsForSaleProperties_chapter_graphql.bs.js");
var NotificationSettingsForSaleProperties_notificationSetting_graphql = require("../../__generated__/NotificationSettingsForSaleProperties_notificationSetting_graphql.bs.js");
var NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql = require("../../__generated__/NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.bs.js");

var forSalePropertyTypeEnumV5_decode = NotificationSettingsForSaleProperties_notificationSetting_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var propertyNotificationPreferenceMLSStatus_decode = NotificationSettingsForSaleProperties_notificationSetting_graphql.Utils.propertyNotificationPreferenceMLSStatus_decode;

var convertFragment = NotificationSettingsForSaleProperties_notificationSetting_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsForSaleProperties_notificationSetting_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsForSaleProperties_notificationSetting_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsForSaleProperties_notificationSetting_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsForSaleProperties_notificationSetting_graphql.node, convertFragment, fRef);
}

var NotificationSettingFragment_forSalePropertyTypeEnumV5_fromString = NotificationSettingsForSaleProperties_notificationSetting_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var NotificationSettingFragment_propertyNotificationPreferenceMLSStatus_fromString = NotificationSettingsForSaleProperties_notificationSetting_graphql.Utils.propertyNotificationPreferenceMLSStatus_fromString;

var NotificationSettingFragment = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: NotificationSettingFragment_forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: NotificationSettingFragment_propertyNotificationPreferenceMLSStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = NotificationSettingsForSaleProperties_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsForSaleProperties_chapter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsForSaleProperties_chapter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsForSaleProperties_chapter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsForSaleProperties_chapter_graphql.node, convertFragment$1, fRef);
}

var ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertVariables = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertVariables;

var convertResponse = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables, NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_decode = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_decode;

var UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_fromString = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_fromString;

var UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_decode = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_decode;

var UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_fromString = NotificationSettingsForSaleProperties_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_fromString;

var UpdateUserNotificationSettingsV5Mutation = {
  broadcastMessageNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_fromString,
  entityNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_decode,
  entityNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function NotificationSettingsForSaleProperties(props) {
  var onFailed = props.onFailed;
  var onSuccess = props.onSuccess;
  var chapter = use$1(props.chapter);
  var notificationSetting = use(props.notificationSetting);
  var match = use$2();
  var updateUserNotificationSettings = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsEditing = match$1[1];
  var isEditing = match$1[0];
  var match$2 = notificationSetting.forSaleProperties;
  var selectedSetting;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "ChapterDefaultNotificationSetting" :
          selectedSetting = "CHAPTER_DEFAULT";
          break;
      case "CustomPropertyNotificationPreference" :
          selectedSetting = "CUSTOM";
          break;
      case "MatchesOnlyNotificationSetting" :
          selectedSetting = "MATCH_ONLY";
          break;
      case "__unselected" :
          selectedSetting = undefined;
          break;
      
    }
  } else {
    selectedSetting = undefined;
  }
  var match$3 = notificationSetting.forSaleProperties;
  var userHasInactiveCustomPreference;
  if (match$3 !== undefined) {
    switch (match$3.__typename) {
      case "ChapterDefaultNotificationSetting" :
      case "MatchesOnlyNotificationSetting" :
          userHasInactiveCustomPreference = match$3.userHasInactiveCustomPreference;
          break;
      case "CustomPropertyNotificationPreference" :
      case "__unselected" :
          userHasInactiveCustomPreference = false;
          break;
      
    }
  } else {
    userHasInactiveCustomPreference = false;
  }
  if (selectedSetting === undefined) {
    return null;
  }
  var match$4 = notificationSetting.forSaleProperties;
  var preferenceData = match$4 !== undefined && match$4.__typename === "CustomPropertyNotificationPreference" ? ({
        areaGroup: match$4.areaGroup,
        maxPrice: match$4.maxPrice,
        minPrice: match$4.minPrice,
        mlsStatus: match$4.mlsStatus,
        propertyTypes: match$4.propertyTypes,
        fragmentRefs: match$4.fragmentRefs
      }) : undefined;
  var tmp;
  if (preferenceData !== undefined) {
    var areaGroup = preferenceData.areaGroup;
    tmp = areaGroup !== undefined ? Caml_option.some(JsxRuntime.jsx(NotificationSettingsComponents.PreferenceSummary.make, {
                tanType: "ForSale",
                minPrice: preferenceData.minPrice,
                maxPrice: preferenceData.maxPrice,
                propertyTypes: Core__Array.filterMap(Core__Option.getOr(preferenceData.propertyTypes, []), (function (v) {
                        return forSalePropertyTypeEnumV5_decode(v);
                      })),
                mlsStatus: Core__Option.flatMap(preferenceData.mlsStatus, (function (v) {
                        return propertyNotificationPreferenceMLSStatus_decode(v);
                      })),
                areaGroup: areaGroup.fragmentRefs,
                chapter: chapter.fragmentRefs
              })) : undefined;
  } else {
    tmp = undefined;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(NotificationSettingsComponents.PreferenceSelectorForm.make, {
                      title: "Properties",
                      text: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                            children: [
                              "You will always be notified of properties that match your buyer needs.",
                              JsxRuntime.jsx("br", {}),
                              "Which other property emails do you want to receive?"
                            ]
                          }),
                      disabled: match[1],
                      value: selectedSetting,
                      onChange: (function (v) {
                          switch (v) {
                            case "CUSTOM" :
                                if (!userHasInactiveCustomPreference) {
                                  return setIsEditing(function (param) {
                                              return true;
                                            });
                                }
                                break;
                            case "CHAPTER_DEFAULT" :
                            case "MATCH_ONLY" :
                                break;
                            
                          }
                          updateUserNotificationSettings({
                                input: {
                                  __$inputUnion: "property",
                                  _0: v
                                }
                              }, undefined, undefined, undefined, (function (param, param$1) {
                                  var updateUserNotificationSettingsV5 = param.updateUserNotificationSettingsV5;
                                  if (updateUserNotificationSettingsV5 !== undefined && updateUserNotificationSettingsV5.__typename === "UserNotificationSettingsWasUpdated") {
                                    return onSuccess();
                                  } else {
                                    return onFailed();
                                  }
                                }), undefined, undefined);
                        }),
                      renderSummary: tmp,
                      onPressEdit: (function () {
                          setIsEditing(function (param) {
                                return true;
                              });
                        }),
                      entityType: "FOR_SALE_PROPERTY"
                    }),
                isEditing ? JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog.make, {
                        entityType: {
                          NAME: "FOR_SALE_PROPERTY",
                          VAL: Core__Option.map(preferenceData, (function (param) {
                                  return param.fragmentRefs;
                                }))
                        },
                        chapter: chapter.fragmentRefs,
                        settings: notificationSetting.fragmentRefs,
                        isOpen: isEditing,
                        onClose: (function () {
                            setIsEditing(function (param) {
                                  return false;
                                });
                          })
                      }) : null
              ]
            });
}

var make = NotificationSettingsForSaleProperties;

exports.NotificationSettingFragment = NotificationSettingFragment;
exports.ChapterFragment = ChapterFragment;
exports.UpdateUserNotificationSettingsV5Mutation = UpdateUserNotificationSettingsV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
